import { Button, Chip, Stack, Typography } from "@mui/material";
import { GridRowModel } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { EditButton } from "./EditButton";

export const NavigateToAwbOrder = ({ awbNo }: { awbNo: string }) => {
  const location = useLocation();

  return (
    <Link
      to={`/order/details/${awbNo}`}
      state={{ prevurl: location.pathname + location.search }}
    >
      <Typography fontWeight={600} color={"#004982"}>
        {awbNo}
      </Typography>
    </Link>
  );
};

export const NavigateToTrakingOrder = ({ order_id, awbNo }: { order_id: string, awbNo: string }) => {
  const location = useLocation();

  return (
    <Link
      target={"_blank"}
      to={`/tracking/${order_id}`}
      state={{ prevurl: location.pathname + location.search }}
    >
      <Typography fontWeight={600} color={"#004982"}>
        {awbNo}
      </Typography>
    </Link>
  );
};

export interface OrderRowType {
  id: number;
  is_rto: string;
  awb: string | null;
  description: string;
  created: string;
  from: string;
  order_channel: string;
  to: string;
  amount: string;
  receiver: string;
  receiver_address: string;
  shipper: string;
  shipper_address: string;
  status: string;
  pickup_time: string | null;
  track_time: string;
  ref_no: string | number;
  label: string;
  invoice_number: string;
  invoice_status: string;
  vendor: string;
  package_details: {
    lenght: number;
    width: number;
    height: number;
    number_pieces: number;
    weight: Number;
  };
  return_awb: string | null;
}

export interface PickupOrderRowType {
  id: number;
  pickupId: string;
  shipmentCount: string;
  pickupAddress: string;
  parentCourier: string;
  pickupStatus: string;
  manifestDetails: string;
  action?: string;
}

export const orderColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "awb",
    headerName: "AWB",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToTrakingOrder order_id={params.row.id} awbNo={params.row.awb} />
      </>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "pickup_number",
    headerName: "Pickup Number",
    minWidth: 140,
    flex: 1,
  },

  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },
  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `Rs ${params.row.amount}` : "0.00"}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <EditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },
];

export const orderPickupColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "awb",
    headerName: "AWB",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToTrakingOrder order_id={params.row.id} awbNo={params.row.awb} />
      </>
    ),
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "pickup_number",
    headerName: "Pickup Number",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },
  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `Rs ${params.row.amount}` : "0.00"}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <EditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },
];

export const orderReadyToShipColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },

  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `Rs ${params.row.amount}` : "0.00"}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <EditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },
];

export const pickupColumns = [
  { field: "id", headerName: "ID", minWidth: 50 },
  {
    field: "pickupId",
    headerName: "Pickup Id / Pickup Request Date",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Link to={`/order/${params.row.pickupId}`}>
        <Typography fontWeight={600} color={"blue"}>
          {params.row.pickupId}
        </Typography>
      </Link>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "shipmentCount",
    headerName: "Shipment Count",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "pickupAddress",
    headerName: "Pickup Address",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "parentCourier",
    headerName: "Parent Courier",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "pickupStatus",
    headerName: "Pickup Status",
    minWidth: 160,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        label={<Typography fontSize={10}>{params.row.pickupStatus}</Typography>}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "manifestDetails",
    headerName: "Manifest Details",
    minWidth: 160,
    flex: 1,
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Stack direction={"row"} justifyContent={"center"} alignItems={"center"}>
        <Button variant="contained">
          <Typography textTransform={"none"} fontSize={10}>
            Download Manifest
          </Typography>
        </Button>
      </Stack>
    ),
  },
];

export const orderCancelColumns = [
  {
    field: "id",
    headerName: "ID",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.id} />
      </>
    ),
  },
  {
    field: "order_channel",
    headerName: "Channel",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "awb",
    headerName: "AWB",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToTrakingOrder order_id={params.row.id} awbNo={params.row.awb} />
      </>
    ),
  },

  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "pickup_number",
    headerName: "Pickup Number",
    minWidth: 140,
    flex: 1,
  },

  {
    field: "from",
    headerName: "From",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <div
        style={{
          fontSize: "12px",
        }}
      >
        <span>{params.row.from}</span> <br />
        <span>{params.row.to}</span>
      </div>
    ),
  },
  { field: "receiver", headerName: "Receiver", minWidth: 140, flex: 1 },
  { field: "vendor", headerName: "Vendor", minWidth: 140, flex: 1 },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <Typography fontWeight={600} color={"#004982"}>
        {params.row.amount ? `Rs ${params.row.amount}` : "0.00"}
      </Typography>
    ),
  },
  { field: "comments", headerName: "Remark", minWidth: 140, flex: 1 },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <Chip
        sx={{
          padding: "1px 1px",
        }}
        label={params.row.status}
        variant="outlined"
        color="success"
      />
    ),
  },
  {
    field: "Action",
    headerName: "Action",
    minWidth: 250,
    flex: 1,

    renderCell: (params: { row: GridRowModel }) => (
      <EditButton
        showBook="both"
        id={params.row.id}
        status={params.row.status}
        vendor={params.row.vendor}
      />
    ),
  },
];

export const TabCol = [
  [
    {
      index: 0,
      column: orderReadyToShipColumns,
    },
    {
      index: 1,
      column: orderColumns,
    },
    {
      index: 2,
      column: orderPickupColumns,
    },
    {
      index: 3,
      column: orderColumns,
    },
    {
      index: 4,
      column: orderColumns,
    },
    {
      index: 5,
      column: orderColumns,
    },
    {
      index: 6,
      column: orderColumns,
    },
    {
      index: 7,
      column: orderColumns,
    },
    {
      index: 8,
      column: orderCancelColumns,
    },
    {
      index: 9,
      column: orderColumns,
    },
    {
      index: 10,
      column: orderColumns,
    },
  ],

  [
    {
      index: 0,
      column: orderCancelColumns,
    },
    {
      index: 1,
      column: orderCancelColumns,
    },
    {
      index: 2,
      column: orderCancelColumns,
    },
    {
      index: 3,
      column: orderCancelColumns,
    },
    {
      index: 4,
      column: orderCancelColumns,
    },
  ],
];
